module.exports = __webpack_public_path__ + "static/media/logo_parc_expo.6b881d97.svg";